import React from "react";
import { Link } from 'react-router-dom';
import './Admissions.css';
import admissionsBg from '../assets/background/Admissions.png';

const Admissions = () => (
  <>
    {/* Hero Section */}
    <section className="admissions-hero">
      <div className="hero-background">
        <img src={admissionsBg} alt="" />
      </div>
      <div className="hero-overlay"></div>
      <div className="container">
        <div className="content">
          <div className="hero-text">
            <div className="padding">
              <h1>Admissions</h1>
              <h2>Join the MPSc Program</h2>
              <p>Take the first step towards a career in applied psychological science. Our competitive program seeks students with strong academic records and a passion for applying psychological research to real-world problems.</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* Requirements Section */}
    <section className="requirements">
      <div className="container">
        <div className="requirements-content">
          <div className="requirements-header">
            <h2>Admission Requirements</h2>
            <p>To be eligible for the MPSc program, applicants must meet the following criteria:</p>
          </div>
          
          <div className="requirements-grid">
            <div className="requirement-card">
              <div className="requirement-icon">
                <i className="fas fa-graduation-cap"></i>
              </div>
              <h3>Academic Background</h3>
              <p>A student must hold an Honours Bachelor's degree or its equivalent in Psychology to be eligible to apply.</p>
            </div>
            
            <div className="requirement-card">
              <div className="requirement-icon">
                <i className="fas fa-chart-line"></i>
              </div>
              <h3>Academic Record</h3>
              <p>Admission to this program is competitive and applicants should have a strong academic record.</p>
            </div>
            
            <div className="requirement-card">
              <div className="requirement-icon">
                <i className="fas fa-file-alt"></i>
              </div>
              <h3>GRE Scores</h3>
              <p>Though not required, GRE scores may be submitted to strengthen an application.</p>
            </div>
            
            <div className="requirement-card">
              <div className="requirement-icon">
                <i className="fas fa-users"></i>
              </div>
              <h3>Letters of Reference</h3>
              <p>Letters of reference should be submitted directly to the School of Graduate Studies on the appropriate forms.</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* Application Process Section */}
    <section className="application-process">
      <div className="container">
        <div className="process-content">
          <div className="process-header">
            <h2>Application Process</h2>
            <p>Follow these steps to complete your application:</p>
          </div>
          
          <div className="process-timeline">
            <div className="process-step">
              <div className="step-number">1</div>
              <div className="step-content">
                <h3>Complete Online Application</h3>
                <p>Application forms can be filled out online through the <a href="https://www.mun.ca/become/graduate/apply-to-memorial/" target="_blank" rel="noopener noreferrer">School of Graduate Studies portal</a>.</p>
              </div>
            </div>
            
            <div className="process-step">
              <div className="step-number">2</div>
              <div className="step-content">
                <h3>Submit Required Documents</h3>
                <p>Upload transcripts, letters of reference, and any additional supporting materials.</p>
              </div>
            </div>
            
            <div className="process-step">
              <div className="step-number">3</div>
              <div className="step-content">
                <h3>Application Review</h3>
                <p>The admissions committee reviews all applications and supporting materials.</p>
              </div>
            </div>
            
            <div className="process-step">
              <div className="step-number">4</div>
              <div className="step-content">
                <h3>Admission Decision</h3>
                <p>Admission decisions are normally made by April 1st.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* Important Dates Section */}
    <section className="important-dates">
      <div className="container">
        <div className="dates-content">
          <div className="dates-header">
            <h2>Important Dates</h2>
            <p>Mark these key dates in your calendar:</p>
          </div>
          
          <div className="dates-grid">
            <div className="date-card">
              <div className="date-icon">
                <i className="fas fa-calendar-alt"></i>
              </div>
              <h3>Application Deadline</h3>
              <div className="date">February 1st</div>
              <p>All applications must be submitted by this date. Late applications may be considered if openings are available.</p>
            </div>
            
            <div className="date-card">
              <div className="date-icon">
                <i className="fas fa-clock"></i>
              </div>
              <h3>Decision Notification</h3>
              <div className="date">April 1st</div>
              <p>Admission decisions are normally made by this date. Applicants will be notified via email.</p>
            </div>
            
            <div className="date-card">
              <div className="date-icon">
                <i className="fas fa-university"></i>
              </div>
              <h3>Program Start</h3>
              <div className="date">September</div>
              <p>The MPSc program begins in the fall semester. Orientation and registration details will be provided to admitted students.</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* Contact Section */}
    <section className="admissions-contact">
      <div className="container">
        <div className="contact-content">
          <div className="contact-header">
            <h2>Questions About Admissions?</h2>
            <p>Our admissions team is here to help you:</p>
          </div>
          
          <div className="contact-info">
            <div className="contact-card">
              <div className="contact-icon">
                <i className="fas fa-envelope"></i>
              </div>
              <h3>Email Us</h3>
              <p>cbutton@mun.ca</p>
              <p>For general inquiries about the program and application process.</p>
            </div>
            
            <div className="contact-card">
              <div className="contact-icon">
                <i className="fas fa-phone"></i>
              </div>
              <h3>Call Us</h3>
              <p>(709) 864-8496</p>
              <p>Available during business hours for immediate assistance.</p>
            </div>
            
            <div className="contact-card">
              <div className="contact-icon">
                <i className="fas fa-question-circle"></i>
              </div>
              <h3>FAQ</h3>
              <p><Link to="/faq" className="faq-link">View Frequently Asked Questions</Link></p>
              <p>Find answers to common questions about admissions and the program.</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* Call to Action */}
    <section className="admissions-cta">
      <div className="container">
        <div className="cta-content">
          <h2>Ready to Apply?</h2>
          <p>Start your application today and join the next generation of applied psychological scientists.</p>
          <div className="cta-buttons">
            <a href="https://www.mun.ca/become/graduate/apply-to-memorial/" className="btn">Apply Now</a>
          </div>
        </div>
      </div>
    </section>
  </>
);

export default Admissions; 